// extracted by mini-css-extract-plugin
export default {"textArea":"textarea_textArea__1iakt"};